import { debounce } from "../utilities/limiters";

document.querySelectorAll( '.steps' ).forEach( steps => {
  const slider = steps.querySelector( '.steps__slider' );
  const slides = slider.querySelectorAll( '.steps__card' );

  if ( slides.length === 0 ) return;

  setState();
  function setState() {
    for ( let i = 0; i < slides.length; i++ ) {
      const slide = slides[i];
      const nextTop = slides[i + 1]?.offsetTop ?? -500;
      const top = slide.offsetTop;

      if ( top > nextTop - 5 && top < nextTop + 5 ) {
        slide.classList.remove( 'last-in-row' );
      } else {
        slide.classList.add( 'last-in-row' );
      }
    }
  }

  window.addEventListener( 'resize', debounce( setState, 600 ) );
} );